import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { ShipmentStatus } from '../enums/ShipmentStatus'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'

export class ShipmentFilterEntity {
  shipmentId?: string
  orderId?: string
  driver?: DriverEntity
  jobId?: string
  deliveryOrderId?: string
  status?: ShipmentStatus
  deliveryId?: string
  jobBranchId?: string
  region?: RegionMiniEntity
  date?: Date[]
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
  orderUser?: UserMiniEntity
  referenceCode?: string
}
